import { el, clear } from '../../utils/dom.js';
import { Items, Categories, Subcategories, Locations } from '../../api/resources.js';
import { field, readForm } from '../../components/form.js';
import { ok, err } from '../../components/toast.js';
import { navigate } from '../../router/index.js';

export default async function InventoryFormPage(outlet, ctx) {
  clear(outlet);
  const isEdit = !!ctx.params.id;
  let item = {};
  let cats = [], subs = [], locs = [];

  try {
    [cats, subs, locs] = await Promise.all([
      Categories.list({ limit: 200 }).then((r) => r.data || []),
      Subcategories.list({ limit: 500 }).then((r) => r.data || []),
      Locations.list({ limit: 200 }).then((r) => r.data || []),
    ]);
    if (isEdit) item = await Items.get(ctx.params.id);
  } catch (ex) {
    outlet.innerHTML = `<div class="empty">Error: ${ex.message}</div>`;
    return;
  }

  outlet.appendChild(el('div', { class: 'page-head' },
    el('h1', {}, isEdit ? `Editar item — ${item.name}` : 'Nuevo item'),
    el('a', { href: '#/inventory', class: 'btn ghost' }, '← Volver'),
  ));

  const form = el('form', {
    onsubmit: async (e) => {
      e.preventDefault();
      const data = readForm(form);
      if (!data.kind) data.kind = 'bulk';
      try {
        const result = isEdit ? await Items.update(item.id, stripImmutable(data)) : await Items.create(data);
        ok(isEdit ? 'Item actualizado' : 'Item creado');
        navigate(`/inventory/${result.id}`);
      } catch (ex) { err(ex.message); }
    },
  });

  const card = el('div', { class: 'card' });
  const grid = el('div', { class: 'form-grid' });

  grid.append(
    field({ name: 'kind', label: 'Tipo', type: 'select', value: item.kind || 'bulk', required: true, disabled: isEdit, options: [
      { value: 'bulk',       label: 'Bulk (cantidad)' },
      { value: 'serialized', label: 'Serializado (unidades unicas)' },
    ]}),
    field({ name: 'name', label: 'Nombre', value: item.name, required: true }),
    field({ name: 'category_id', label: 'Categoria', type: 'select', value: item.category_id, options: cats.map((c) => ({ value: c.id, label: c.name })) }),
    field({ name: 'subcategory_id', label: 'Subcategoria', type: 'select', value: item.subcategory_id, options: subs.map((s) => ({ value: s.id, label: `${s.category_name} > ${s.name}` })) }),
    field({ name: 'brand', label: 'Marca', value: item.brand }),
    field({ name: 'model', label: 'Modelo', value: item.model }),
    field({ name: 'internal_code', label: 'Codigo interno', value: item.internal_code }),
    field({ name: 'provider', label: 'Proveedor', value: item.provider }),
    field({ name: 'default_purchase_price', label: 'Precio compra', value: item.default_purchase_price, type: 'number', step: '0.01' }),
    field({ name: 'default_estimated_value', label: 'Valor estimado', value: item.default_estimated_value, type: 'number', step: '0.01' }),
    field({ name: 'default_rental_price_per_day', label: 'Precio renta/dia', value: item.default_rental_price_per_day, type: 'number', step: '0.01' }),
    field({ name: 'default_location_id', label: 'Ubicacion default', type: 'select', value: item.default_location_id, options: locs.map((l) => ({ value: l.id, label: l.name })) }),
  );

  // Solo bulk: stock
  const bulkSection = el('div', { class: 'full', style: 'display: contents' },
    field({ name: 'quantity_total', label: 'Stock total (bulk)', value: item.quantity_total, type: 'number', step: '1', min: '0', disabled: isEdit, hint: isEdit ? 'Usa "ajustar stock" en la ficha' : '' }),
    field({ name: 'min_stock', label: 'Stock minimo', value: item.min_stock, type: 'number', step: '1', min: '0' }),
    field({ name: 'max_stock', label: 'Stock maximo', value: item.max_stock, type: 'number', step: '1', min: '0' }),
  );
  grid.appendChild(bulkSection);

  grid.appendChild(field({ name: 'description', label: 'Descripcion', value: item.description, type: 'textarea', full: true }));
  grid.appendChild(field({ name: 'notes', label: 'Notas internas', value: item.notes, type: 'textarea', full: true }));
  grid.appendChild(field({ name: 'publicado_web', label: 'Mostrar en el catálogo web de alquiler', type: 'checkbox', value: !!item.publicado_web }));
  grid.appendChild(field({ name: 'descripcion_web', label: 'Descripción para el catálogo (opcional)', value: item.descripcion_web, type: 'textarea', full: true,
    hint: 'Lo que ve el cliente. Si la dejas vacía, se usa la descripción.' }));

  card.appendChild(grid);
  card.appendChild(el('div', { class: 'flex gap-2 justify-between mt-3' },
    el('a', { href: '#/inventory', class: 'btn' }, 'Cancelar'),
    el('button', { class: 'btn primary', type: 'submit' }, isEdit ? 'Guardar cambios' : 'Crear item'),
  ));
  form.appendChild(card);
  outlet.appendChild(form);
}

function stripImmutable(d) {
  const out = { ...d };
  delete out.kind;
  delete out.quantity_total;
  return out;
}
